import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  logged:boolean = false
  username:string
  password:string
  constructor(public loginService:LoginService) { }

  ngOnInit() {

  }
  login(){
  	this.loginService.login(this.username, this.password)
  }
  logout(){
    this.loginService.logout()
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts